import { AnimatePresence, motion } from "framer-motion";
import { NotebookPen } from "lucide-react";
import { useApp } from "@/context/AppContext";

export const PresenterNotes = ({ notes }) => {
  const { presenter, t } = useApp();
  return (
    <AnimatePresence>
      {presenter && (
        <motion.div
          key="presenter"
          initial={{ y: "100%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "100%", opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.85, 0, 0.15, 1] }}
          className="fixed bottom-1 left-0 right-0 z-40 border-t border-white/10 bg-navy-900/85 backdrop-blur-2xl"
          data-testid="presenter-notes"
        >
          <div className="mx-auto max-w-4xl px-6 py-5 sm:px-10">
            <div className="mb-2 flex items-center gap-2 text-champagne">
              <NotebookPen className="h-4 w-4" strokeWidth={1.5} />
              <span className="text-xs font-semibold uppercase tracking-[0.2em]">
                {t.ui.presenterNotes}
              </span>
            </div>
            <p className="text-sm leading-relaxed text-cream/90 sm:text-base">{notes}</p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
